import { Col, Container, Row } from 'react-bootstrap';
import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import CircledIcon from '../../../../components/CircledIcon';
import GenericCard from '../../../../components/GenericCards/GenericCards';
import Link from '../../../../components/Link';
import VideoCard from '../../../../components/VideoCard';
import videoCardImg from '../../../../assets/video-card.png';
import FAQsHealthAndInsuranceModal from '../../FAQsHealthAndInsuranceModal';
import useModal from '../../../../hooks/useModal';
import FAQsSiteModal from '../../FAQsSiteModal';
import VideoEmbedModal from '../../VideoEmbedModal/VideoEmbedModal';
import { stopVideo } from '../../../../utils/utils';

const documentsOptions = [
  {
    title: 'Health & Insurance',
    iconR: light('chevron-right'),
    iconCircle: light('comments-question-check'),
  },

  {
    title: 'Site',
    iconR: light('chevron-right'),
    iconCircle: light('comments-question-check'),
  },
];

const FAQs = () => {
  const [
    showFAQsHealthAndInsuranceModal,
    handleShowFAQsHealthAndInsuranceModal,
    handleCloseFAQsHealthAndInsuranceModal,
  ] = useModal();

  const [showFAQsSiteModal, handleShowFAQsSiteModal, handleCloseFAQsSiteModal] =
    useModal();

  //references to all show modal functions
  const modalsShowHandlers = [
    handleShowFAQsHealthAndInsuranceModal,
    handleShowFAQsSiteModal,
  ];

  const [
    showVideoEmbedModal,
    handleShowVideoEmbedModal,
    handleCloseVideoEmbedModal,
  ] = useModal();

  return (
    <>
      <FAQsHealthAndInsuranceModal
        showFAQsHealthAndInsuranceModal={showFAQsHealthAndInsuranceModal}
        handleCloseFAQsHealthAndInsuranceModal={
          handleCloseFAQsHealthAndInsuranceModal
        }
      />

      <FAQsSiteModal
        showFAQsSiteModal={showFAQsSiteModal}
        handleCloseFAQsSiteModal={handleCloseFAQsSiteModal}
      />

      <Container className={'px-0'}>
        <Row sm={1} className={'mx-0'}>
          <Col className={'px-0 mx-0 col-lg-8'}>
            <Row className={'row-cols-lg-1 mx-0'}>
              {documentsOptions.map((genericCard, index) => {
                return (
                  <div key={index} className={'px-0 pe-lg-7 pe-sm-0'}>
                    <GenericCard className={'p-7 mt-7'} variant={'white'}>
                      <Container className={'d-flex align-items-center px-0'}>
                        <CircledIcon
                          variant="icon-emphasized"
                          icon={genericCard.iconCircle}
                        />
                        <Container className={'w-100 px-0 ms-7'}>
                          <Link
                            onMouseDown={modalsShowHandlers[index]}
                            rightIcon={genericCard.iconR}
                            isBlue
                            isAlignAtEnd
                          >
                            <h6 className="text-fs-6 mb-0 fw-normal">
                              {genericCard.title}
                            </h6>
                          </Link>
                        </Container>
                      </Container>
                    </GenericCard>
                  </div>
                );
              })}
            </Row>
          </Col>

          <Col lg={true} className={'px-0 mt-7'}>
            <div
              className={'video-card-container'}
              style={{ margin: '0 auto' }}
            >
              <VideoCard
                videoLink={'#'}
                title={'HSA Overview Video'}
                videoCardImg={videoCardImg}
                alt={'HSA Overview Video'}
                onClick={handleShowVideoEmbedModal}
              />

              <VideoEmbedModal
                showVideoEmbedModal={showVideoEmbedModal}
                handleCloseVideoEmbedModal={handleCloseVideoEmbedModal}
                stopVideo={stopVideo}
                videoLink={'https://www.youtube.com/embed/qE5pwDEvxGk'}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default FAQs;
